import { useState, useEffect, useCallback } from 'react'
import { proveedoresApi } from '../api/compras'
import Modal from './Modal'

// Buscador avanzado de proveedores (F6): igual al de clientes de la NV
// (ModalListaClientes, pedido de Martin 15 sep 2026). Paginado server-side por
// nombre, fantasía, CUIT o código. Los dados de alta en LGR muestran "LGR".
export default function ModalListaProveedores({ onSelect, onClose }) {
  const [q, setQ] = useState('')
  const [proveedores, setProveedores] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [lastPage, setLastPage] = useState(1)
  const [total, setTotal] = useState(0)

  const cargar = useCallback(async (busq, pg) => {
    setLoading(true)
    try {
      const params = { page: pg, per_page: 30 }
      if (busq) params.q = busq
      const { data } = await proveedoresApi.listar(params)
      setProveedores(data.data || [])
      setLastPage(data.last_page || 1)
      setTotal(data.total || 0)
    } catch { setProveedores([]); setTotal(0) } finally { setLoading(false) }
  }, [])

  useEffect(() => { cargar(q, page) }, [q, page, cargar])

  const handleQ = (e) => { setQ(e.target.value); setPage(1) }

  return (
    <Modal title="Seleccionar proveedor (F6)" onClose={onClose} maxWidth="640px">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <input
          autoFocus
          style={{ padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.875rem' }}
          placeholder="Buscar por nombre, CUIT o código..."
          value={q} onChange={handleQ}
        />
        <div style={{ fontSize: '0.8rem', color: '#64748b' }}>{total} proveedores</div>
        {/* Altura FIJA (no maxHeight): el modal no cambia de tamaño mientras se
            tipea la búsqueda — la lista scrollea adentro (regla Martin 14 ago). */}
        <div style={{ height: '380px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '6px' }}>
          {loading ? (
            <p style={{ padding: '1rem', color: '#94a3b8', textAlign: 'center' }}>Cargando...</p>
          ) : proveedores.length === 0 ? (
            <p style={{ padding: '1rem', color: '#94a3b8', textAlign: 'center' }}>Sin resultados.</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ background: '#f8fafc' }}>
                  <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', fontWeight: '600', color: '#475569', borderBottom: '1px solid #e2e8f0' }}>Código</th>
                  <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', fontWeight: '600', color: '#475569', borderBottom: '1px solid #e2e8f0' }}>Nombre</th>
                  <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', fontWeight: '600', color: '#475569', borderBottom: '1px solid #e2e8f0' }}>CUIT</th>
                  <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', fontWeight: '600', color: '#475569', borderBottom: '1px solid #e2e8f0' }}>Localidad</th>
                </tr>
              </thead>
              <tbody>
                {proveedores.map(p => (
                  <tr
                    key={p.id}
                    onClick={() => onSelect(p)}
                    style={{ borderBottom: '1px solid #f1f5f9', cursor: 'pointer' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#eff6ff'}
                    onMouseLeave={e => e.currentTarget.style.background = ''}
                  >
                    <td style={{ padding: '0.5rem 0.75rem', fontFamily: 'monospace', fontWeight: 700 }}>{p.codigo_presea || 'LGR'}</td>
                    <td style={{ padding: '0.5rem 0.75rem' }}>{p.nombre}</td>
                    <td style={{ padding: '0.5rem 0.75rem', fontFamily: 'monospace', fontSize: '0.8125rem' }}>{p.cuit || '—'}</td>
                    <td style={{ padding: '0.5rem 0.75rem', color: '#64748b' }}>{p.localidad || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        {/* La fila del paginador SIEMPRE ocupa su lugar (visibility, no unmount). */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', fontSize: '0.875rem', visibility: lastPage > 1 ? 'visible' : 'hidden' }}>
          <button disabled={page <= 1} onClick={() => setPage(p => p - 1)} style={{ padding: '0.3rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', cursor: 'pointer', background: 'white' }}>← Ant.</button>
          <span>Pág. {page} / {lastPage}</span>
          <button disabled={page >= lastPage} onClick={() => setPage(p => p + 1)} style={{ padding: '0.3rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', cursor: 'pointer', background: 'white' }}>Sig. →</button>
        </div>
      </div>
    </Modal>
  )
}
